import { createAction, props } from '@ngrx/store';
import { NextStep } from '@shared/models/next-step';

export const loadNextStepSuccess = createAction(
  '[Next Steps] Load Next Step Success',
  props<{ nextStep: NextStep | undefined }>(),
);
